<template>
  <div :class="{'is-searching': searching}" class="flex">
    <div id="searchContainer">
      <input ref="input" v-model="formValue" type="text" placeholder="Search..." @blur="onBlur" @keydown.esc="$refs.input.blur()">
    </div>
    <d-tooltip v-if="tooltip" :label="tooltip" position="bottom" multilined>
      <d-btn id="searchButton" icon @click.native.stop="searchBegin">
        <d-icon icon="search" />
      </d-btn>
    </d-tooltip>
    <d-btn v-else id="searchButton" icon @click.native.stop="searchBegin">
      <d-icon icon="search" />
    </d-btn>
  </div>
</template>
<script>
  export default {
    props: {
      value: String,
      tooltip: String,
    },

    data: () => ({
      searching: false,
    }),

    computed: {
      formValue: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
    },

    watch: {
      formValue(val) {
        if (val) {
          this.searching = true;
        }
      },
    },

    mounted() {
      if (this.formValue) {
        this.searching = true;
      }
    },

    methods: {
      onFocus() {
        this.formValue = '';
      },

      onBlur() {
        if (!this.formValue) {
          this.searching = false;
        }
      },

      searchBegin() {
        this.searching = true;
        setTimeout(() => this.$refs.input.focus(), 50);
      },

      searchEnd() {
        this.searching = false;
        this.formValue = '';
        this.$refs.input.blur();
      },
    },
  };
</script>

<style scoped>
  #searchContainer {
    overflow: hidden;
    display: inline-block;
    vertical-align: middle;
  }

  #searchContainer input {
    width: 0;
    height: 41px;
    border-radius: 5px 0 0 5px;
    background: rgba(255, 255, 255, 0.3);
    border: 1px solid #ded7d7;
    transform: translateX(-100%);
    opacity: 0;
    transition: opacity 0.45s ease-in-out, transform 0.45s ease-in-out, width 0.45s ease-in-out;
  }

  .is-searching #searchButton {
    border-radius: 0 0.25rem 0.25rem 0;
  }

  .is-searching #searchContainer input {
    width: 300px;
    transform: translateX(0);
    opacity: 1;
    padding-left: 15px;
  }
</style>